import React from 'react';
import {Row, Textarea, Button, Icon, Col} from "react-materialize";
import CryptoFunction from "../functions/CryptoFunctions";

class Input extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {


        return (
            <div className={'card purple lighten-5'}>
                <div className="card-content">
                    <Row>
                        <span className={'ZaglText'}>{this.props.text}</span>
                        <Textarea
                            s={12}
                            m={12}
                            l={12}
                            xl={12}
                            {...this.props.readonly ? 'readonly' : ""}
                            className={"browser-default browser-default-textarea"}
                            onChange={(e)=>{
                                this.props.editInput(e)
                            }}
                            value={this.props.editInputValue}
                        />
                        <Col s={12}>
                            {
                                this.props.onCopy !== null ?
                                <Button flat waves="light"
                                    onClick={()=>this.props.onCopy()}
                            >
                                <Icon>content_copy</Icon>
                            </Button> : null}
                            {
                                this.props.onPaste !== null ?
                                    <Button flat waves="light"
                                            onClick={()=>this.props.onPaste()}
                                    >
                                        <Icon>content_paste</Icon>
                                    </Button>
                                    : null
                            }
                            {/*<Button flat waves="light"*/}
                            {/*        onClick={()=>this.props.onClear()}*/}
                            {/*>*/}
                            {/*    <Icon>clear</Icon>*/}
                            {/*</Button>*/}
                        </Col>
                    </Row>
                </div>
                <div className="card-action">
                    {this.props.isKey ?
                        <Button waves="light" style={{marginRight: '5px'}}
                                className={'purple darken-1'}
                            onClick={()=>{
                                let f = {
                                    target: {
                                        value: CryptoFunction.generateKey()
                                    }
                                };
                                this.props.editInput(f);
                            }}
                        >
                            Генерировать ключ
                        </Button>
                        : null}
                    {this.props.isLongKey ?
                        <Button waves="light" style={{marginRight: '5px'}}
                                className={'purple darken-4'}
                                onClick={()=>{
                                    let f = {
                                        target: {
                                            value: CryptoFunction.generateKey(1024, 128, 4096)
                                        }
                                    };
                                    this.props.editInput(f);
                                }}
                        >
                            Генерировать "сложный" ключ
                        </Button>
                        : null
                    }

                </div>
            </div>
        )
    }
}

export default Input;